module.exports = __webpack_public_path__ + "static/media/markup-neon.2297fd44.svg";